<template>
  <v-container class="text-center py-12">
    <v-icon
      color="error"
      size="128"
      class="mb-6"
    >mdi-alert-circle</v-icon>
    
    <h1 class="text-h2 mb-4">Página não encontrada</h1>
    <p class="text-h5 mb-8">A página que você está procurando não existe ou foi movida.</p>
    
    <v-btn
      color="primary"
      size="large"
      to="/"
    >
      <v-icon left>mdi-home</v-icon>
      Voltar para a página inicial
    </v-btn>
  </v-container>
</template>